import {CommonModule} from '@angular/common';
import {Component, Inject} from '@angular/core';
import {TuiButton, TuiDialogContext} from '@taiga-ui/core';
import {POLYMORPHEUS_CONTEXT} from '@taiga-ui/polymorpheus';

export interface GateweeConfirmDialogData {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

@Component({
  selector: 'gatewee-confirm-dialog',
  standalone: true,
  imports: [CommonModule, TuiButton],
  template: `
    <div class="gw-p-6 gw-space-y-4">
      <h2 class="gw-text-lg gw-font-semibold gw-text-text-primary">
        {{ data.title }}
      </h2>
      <p class="gw-text-sm gw-text-text-secondary">{{ data.message }}</p>
      <div class="gw-flex gw-justify-end gw-gap-2 gw-pt-2">
        <button tuiButton appearance="secondary" (click)="cancel()">
          {{ data.cancelLabel ?? 'Cancelar' }}
        </button>
        <button tuiButton appearance="primary" (click)="confirm()">
          {{ data.confirmLabel ?? 'Prosseguir' }}
        </button>
      </div>
    </div>
  `,
})
export class GateweeConfirmDialogComponent {
  constructor(
    @Inject(POLYMORPHEUS_CONTEXT)
    private readonly context: TuiDialogContext<
      boolean,
      GateweeConfirmDialogData
    >,
  ) {}

  get data(): GateweeConfirmDialogData {
    return this.context.data;
  }

  confirm(): void {
    this.context.completeWith(true);
  }

  cancel(): void {
    this.context.completeWith(false);
  }
}
